<template>
    <a-table :columns="columns" :scroll="{ y: '164px' }" :style="{ width, height }" :dataSource="props.data" size="small" :pagination="false">
      <template #emptyText>
        <Empty />
      </template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'employeeName'">
          {{ record.employeeName || '合计' }}
        </template>
        <template v-else >
          <div style="font-size: smaller">{{ record[column.dataIndex] }}</div>
        </template>
      </template>
    </a-table>
</template>

<script lang="ts" setup>
import { defineProps, PropType, ref, h, computed } from 'vue'
import Empty from '../../componects/Empty.vue'
const props = defineProps({
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '260px'
  },
  data: {
    type: Array as PropType<any[]>,
    default: () => {
      return []
    }
  }
})

const columns = computed(() => [
  { title: tableTitle('业务员'), dataIndex: 'employeeName' },
  { title: tableTitle('合计'), dataIndex: 'totalPartAmount' },
  { title: tableTitle('1-30天'), dataIndex: 'apartAmount' },
  { title: tableTitle('31-60天'), dataIndex: 'bpartAmount' },
  { title: tableTitle('61-90天'), dataIndex: 'cpartAmount' },
  { title: tableTitle('91-180天'), dataIndex: 'dpartAmount' },
  { title: tableTitle('181-360天'), dataIndex: 'epartAmount' },
  { title: tableTitle('360天以上'), dataIndex: 'fpartAmount' }
])

const tableTitle = (n1, n2) => {
  if (!n2) return h('div', { style: { fontSize: "smaller" } }, n1)
  return h('div', { style: { fontSize: "smaller" } }, [
    h('p', null, n1),
    h('span', null, n2)
  ])
}
</script>

<script lang="ts">
export default {
  name: 'OverdueAmountTypeListView'
}
</script>

<style lang="scss" scoped>
.no-bottom-space {
  height: 100%;
  :deep(.ant-table) {
    height: 100%;
  }
  :deep(.ant-table-container) {
    height: 100%;
  }
  :deep(.ant-table-body) {
    margin: 0 !important;
  }
}
</style>